/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import "./styles.scss";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'animated-blobs';

/**
 * This is the component description.
 */
const AnimatedBlobs = ({
  id,
  className: userClassName,
  color,
  style,
  height,
  width,
  opacity
  // ...otherProps
}) => /*#__PURE__*/React.createElement("div", {
  id: id,
  className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
  style: {
    ...style,
    '--blob-color': `var(--${color})`,
    '--height': height,
    '--opacity': opacity,
    '--width': width
  }
}, /*#__PURE__*/React.createElement("div", {
  className: "shape-blob"
}), /*#__PURE__*/React.createElement("div", {
  className: "shape-blob one"
}), /*#__PURE__*/React.createElement("div", {
  className: "shape-blob two"
}));
AnimatedBlobs.propTypes = {
  /**
  * The HTML id for this element
  */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The color of the blobs
   */
  color: PropTypes.string,
  /**
   * The height of the blobs
   */
  height: PropTypes.string,
  /**
   * The width of the blobs
   */
  width: PropTypes.string,
  /**
   * The opacity of the blobs
   */
  opacity: PropTypes.string
};
AnimatedBlobs.defaultProps = {
  color: 'background-mesh',
  height: '200px',
  width: '200px',
  opacity: '0.7'
};
export default AnimatedBlobs;